import { collect } from '@/analytics';

const EVENT = {
  NAME: 'gaEvent',
  CATEGORY: {
    CLOUDFLARE: 'Cloudflare',
  },
  ACTION: {
    MY_ALERTS: 'Gatilho_meus_avisos',
    BOTTOM_BANNER: 'Gatilho_Bottom_Banner',
    BANNER_SITES: 'Gatilho_Banner_Sites',
    SITES_BUTTON: 'Botão_Sites',
    HOSTINGS_BUTTON: 'Botão_Hospedagens',
    MANAGE_CF_SCREEN: 'Tela_gerenciar_CF',
    CF_FEATURES_SCREEN: 'Tela_Features_CF',
    CLICK_VIDEO: 'Click_Video',
  },
};

const cloudflareAlertCta = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.MY_ALERTS,
  gaEventLabel: 'Clique_Desempenho_de_Sites',
});

const bottomBannerCta = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.BOTTOM_BANNER,
  gaEventLabel: 'Clique_Desempenho_de_Sites',
});

const sitesBannerCta = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.BANNER_SITES,
  gaEventLabel: 'Clique_Conheça',
});

const modalCta = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.BANNER_SITES,
  gaEventLabel: 'Clique_Desempenho_de_Sites_Modal',
});

const modalClose = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.BANNER_SITES,
  gaEventLabel: 'Fechar_Modal',
});

const sitesButton = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.SITES_BUTTON,
  gaEventLabel: 'Clique_Desempenho_de_Sites',
});

const hostingsButton = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.HOSTINGS_BUTTON,
  gaEventLabel: 'Clique_Desempenho_de_Sites',
});

const activateHgDomainToggle = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.MANAGE_CF_SCREEN,
  gaEventLabel: 'Toggle_Ativar_Dominio_HG',
});

const deactivateHgDomainToggle = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.MANAGE_CF_SCREEN,
  gaEventLabel: 'Toggle_Desativar_Dominio_HG',
});

const activateExternalDomainToggle = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.MANAGE_CF_SCREEN,
  gaEventLabel: 'Toggle_Ativar_Dominio_Externo',
});

const deactivateExternalDomainToggle = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.MANAGE_CF_SCREEN,
  gaEventLabel: 'Toggle_Desativar_Dominio_Externo',
});

const updateStatusCta = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.MANAGE_CF_SCREEN,
  gaEventLabel: 'Clique_Atualizar_Status',
});

const manageCta = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.MANAGE_CF_SCREEN,
  gaEventLabel: 'Clique_Gerenciar',
});

const cleanCacheCta = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.CF_FEATURES_SCREEN,
  gaEventLabel: 'Clique_Limpar_Cache',
});

const activateDevModeToggle = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.CF_FEATURES_SCREEN,
  gaEventLabel: 'Ativar_Dev_Mode',
});

const deactivateDevModeToggle = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.CF_FEATURES_SCREEN,
  gaEventLabel: 'Desativar_Dev_Mode',
});

const activateUnderAttackToggle = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.CF_FEATURES_SCREEN,
  gaEventLabel: 'Ativar_Modo_Sob_Ataque',
});

const deactivateUnderAttackToggle = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.CF_FEATURES_SCREEN,
  gaEventLabel: 'Desativar_Modo_Sob_Ataque',
});

const activateAlwaysOnlineToggle = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.CF_FEATURES_SCREEN,
  gaEventLabel: 'Ativar_Always_Online',
});

const deactivateAlwaysOnlineToggle = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.CF_FEATURES_SCREEN,
  gaEventLabel: 'Desativar_Always_Online',
});

const clickFeatureSpeedVideo = () => collect({
  event: EVENT.NAME,
  gaEventCategory: EVENT.CATEGORY.CLOUDFLARE,
  gaEventAction: EVENT.ACTION.CLICK_VIDEO,
  gaEventLabel: 'Clique_Desempenho_de_Sites_Video_Explicativo',
});

const analytics = {
  cloudflareAlertCta,
  bottomBannerCta,
  sitesBannerCta,
  modalCta,
  modalClose,
  sitesButton,
  hostingsButton,
  activateHgDomainToggle,
  deactivateHgDomainToggle,
  activateExternalDomainToggle,
  deactivateExternalDomainToggle,
  updateStatusCta,
  manageCta,
  cleanCacheCta,
  activateDevModeToggle,
  deactivateDevModeToggle,
  activateUnderAttackToggle,
  deactivateUnderAttackToggle,
  activateAlwaysOnlineToggle,
  deactivateAlwaysOnlineToggle,
  clickFeatureSpeedVideo,
};

export default analytics;
